export default {name:'卫生间家具',category:['建筑设计','室内'],content:{sink:{name:'洗手台'},'storage rack':{name:'储物架'},bathtub:{name:'浴盆'},'Towel rack':{name:'浴巾架'}}};